import { apiFetch } from "./index";
import { getApiBaseUrl } from "./baseUrl";

const API_BASE = getApiBaseUrl();

export const getUserSettings = async (token: string) => {
  return await apiFetch<UserSettings>(`${API_BASE}/api/management/user-settings`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
};

export const updateMiniSidenav = async (token: string, value: boolean) => {
  return await apiFetch(`${API_BASE}/api/management/mini-sidenav`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ value }),
  });
};

export const updateFixedNavbar = async (token: string, value: boolean) => {
  return await apiFetch(`${API_BASE}/api/management/fixed-navbar`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ value }),
  });
};

export const updateDarkMode = async (token: string, value: boolean) => {
  return await apiFetch(`${API_BASE}/api/management/dark-mode`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ value }),
  });
};

export const updateSidenavColor = async (token: string, value: boolean) => {
  return await apiFetch(`${API_BASE}/api/management/sidenav-color`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ value }),
  });
};

export const updateTransparentSidenav = async (token: string, value: boolean) => {
  return await apiFetch(`${API_BASE}/api/management/transparent-sidenav`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ value }),
  });
};

export const updateWhiteSidenav = async (token: string, value: boolean) => {
  return await apiFetch(`${API_BASE}/api/management/white-sidenav`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ value }),
  });
};

export const updateShowDeadlineBanner = async (token: string, value: boolean) => {
  return await apiFetch(`${API_BASE}/api/management/show-deadline-banner`, {
    method: "POST",
    headers: {
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ value }),
  });
};

export interface UserSettings {
  mini_sidenav: boolean;
  fixed_navbar: boolean;
  sidenav_color:
    | "primary"
    | "secondary"
    | "info"
    | "success"
    | "warning"
    | "error"
    | "light"
    | "dark";
  transparent_sidenav: boolean;
  white_sidenav: boolean;
  dark_mode: boolean;
  show_deadline_banner: boolean;
}
